<template>
  <custom-dialog
    :is-dialog-open="isDialogOpen"
    dialog-title="Associar Departamento"
    max-width="800px"
    :close-dialog="closeDialog"
  >
    <v-form
      ref="formRef"
      class="multi-col-validation"
      @submit.prevent="handleSubmit"
    >
      <v-row>
        <v-col cols="12">
          <v-select
            v-model="departamentoSelecionadoId"
            dense
            outlined
            label="Departamento"
            placeholder="Departamento"
            item-value="id"
            item-text="nome"
            no-data-text="Nenhum departamento disponível"
            :loading="isGetDepartamentosLoading"
            :items="departamentos"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          class="d-flex justify-center"
          cols="12"
        >
          <v-btn
            class="mr-4"
            color="secondary"
            outlined
            @click="resetFormAndCloseDialog"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            type="submit"
            :disabled="loading"
          >
            <v-progress-linear
              v-if="loading"
              class="mx-4"
              indeterminate
              color="secondary"
            />

            <span v-else>Salvar</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </custom-dialog>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import Vue from 'vue'
import CustomDialog from '@/components/dialog/Dialog.vue'
import CargoService from '@/services/modules/CargoService'
import useDialog from '@/composables/useDialog'

export default {
  components: {
    CustomDialog,
  },

  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
    cargoId: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    const { formRef, loading, FORM_ERROR, resetForm, validateForm, emitRefetchData, closeDialog } = useDialog(emit, 'isDialogOpen')

    const departamentoSelecionadoId = ref(null)
    const departamentos = ref([])
    const isGetDepartamentosLoading = ref(false)

    function resetFormAndCloseDialog() {
      resetForm()
      closeDialog()
    }

    async function getDepartamentosNaoAssociados() {
      if (isGetDepartamentosLoading.value) return

      try {
        isGetDepartamentosLoading.value = true
        departamentos.value = await CargoService.getDepartamentosNaoAssociados(props.cargoId)
      } finally {
        isGetDepartamentosLoading.value = false
      }
    }
    watch(
      () => props.isDialogOpen,
      v => {
        if (!v) return
        getDepartamentosNaoAssociados()
      },
      {
        immediate: true,
      },
    )

    async function handleSubmit() {
      if (loading.value) return

      if (!validateForm()) {
        Vue.$toast(FORM_ERROR)
        return
      }

      try {
        loading.value = true
        await CargoService.criarAssociacaoCargoDepartamento(props.cargoId, {
          departamentoId: departamentoSelecionadoId.value,
        })
        emitRefetchData()
        resetFormAndCloseDialog()
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      loading,
      resetForm,
      closeDialog,
      departamentoSelecionadoId,
      departamentos,
      isGetDepartamentosLoading,
      resetFormAndCloseDialog,
      handleSubmit,
    }
  },
}
</script>
